// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrap {
  white-space: normal;
}

.title-col {
  width: 20%;
  padding-left: 6px;
  white-space: normal;
}

.title-col-sm {
  width: 20%;
  white-space: normal;
  padding-left: 6px;
}

.amount-col {
  width: 165px;
  text-align: right;
  width: 15%;
  white-space: normal;
}

.amount-col-lg {
  width: 185px;
  text-align: right;
  width: 15%;
  white-space: normal;
}

.amount-col-sm {
  width: 100px;
  text-align: right;
  width: 15%;
  white-space: normal;
}

.percent-col {
  width: 40px;
  text-align: right;
  width: 10%;
  white-space: normal;
}


.py-2 {
  padding-top: 6px;
  padding-bottom: 6px;
}

.pr-2 {
  padding-right: 6px;
}

.pl-2 {
  padding-left: 6px;
}

.border-bottom {
  border-bottom: 1px solid #ccc;
}

.overflow-x-auto {
  overflow-x: auto;
}

@media print {
  .overflow-x-auto {
    overflow-x: visible;
  }

  .card {
      box-shadow: none;
      margin-bottom: 0px;
  }
}


.report-table {
  min-width: 600px;
}

.d-inline-block {
  display: inline-block;
}

`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
